export default __webpack_public_path__ + "static/media/no-session.e29586a3.svg";